import axios from "axios"
import router from "../router"
import { Message } from "element-ui";
import { GenerateSignature } from "./check";

const instance = axios.create({
    baseURL: process.env["VUE_APP_BASE_URL"] || "/api", // 设置默认值
    timeout: 15000, // 增加超时时间到15秒
    headers: {
        "Content-Type": "application/json"
    }
});

const routerList=['/HomeView','/szbj','/sx','/sjfw','/gywm','login']
// 添加请求拦截器
instance.interceptors.request.use(async function (config) {
    // console.log();
    
    // if(routerList.includes(router.app._route.path)){
      
    //     return config;
    // }
    // 在发送请求之前做些什么
    if(sessionStorage.getItem('token')||localStorage.getItem('token')){
      config.headers.Authorization=sessionStorage.getItem('token')||localStorage.getItem('token')
      // return config
    }
     //取出请求url
     const url = config.url?.split('?')[0] ?? ''
     //取出参数并转换为小写重新排序
     //const query = (config.url?.split('?')[1] ?? '').toLowerCase().split('&').sort().join(':')
     const query = config.url?.split('?')[1] ?? ''
    const request = {
      url: url,
      query: query,
      bodyStr: config.data ? JSON.stringify(config.data) : '',
      Authorization: config.headers.Authorization
    }
    
    try {
      const data = await GenerateSignature(request)
     
      config.headers['X-Timestamp'] = data.XTimestamp
      config.headers['X-Nonce'] = data.XNonce
      config.headers['X-Signature'] = data.XSignature
    } catch (error) {
      console.error('GenerateSignature error:', error)
      // 如果签名生成失败，仍然发送请求，但不包含签名头
    }
   
    return config
 
  }, function (error) {
    // 对请求错误做些什么
    console.error('Request interceptor error:', error)
    return Promise.reject(error);
  });

// 添加响应拦截器
instance.interceptors.response.use(function (response) {
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    
    // 检查是否是 /v1/users/profile 接口
    if (response.config.url && response.config.url.includes('/v1/users/profile')) {
        return response.data;
    }
    
    return response.data.data;
  }, function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
 console.log(error.response,'error');
 
 if(error?.response?.status===401){
  router.push('/login')
  sessionStorage.removeItem('token')
  localStorage.removeItem('token')
  Message({
    message: '登录过期，请重新登录',
    type: 'error'
  });
 } else if (error.code === 'ECONNABORTED' && error.message.includes('timeout')) {
   Message({
     message: '请求超时，请检查网络连接',
     type: 'error'
   });
 }
    return Promise.reject(error);
  });

export default instance